<template>
    <div>
        <h1 style="text-align:center;">Página não encontrada</h1>
        <div style="display:flex; justify-content:center;">
            <a href="/" style="text-align:center;">Voltar a página inicial</a>
        </div>
        
    </div>
</template>
<script>
export default {
    name: 'PageNotFound'
}
</script>
<style>
    
</style>